import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=5adf94ac&scoped=true"
import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf94ac",
  null
  
)

export default component.exports